
import { Component, Vue, Prop } from 'vue-property-decorator'
import { UserModule } from '../../store/modules/user'
import { formatDate } from '../../utils/publish'
import DashboardOrderDetails from './DashboardOrderDetails.vue'
  @Component({ 
    name: 'DashboardOrderList',
    components: { DashboardOrderDetails } 
  })
  
export default class DashboardRatio extends Vue {
  @Prop() saleListData
  @Prop() total_count

  is_show_order_info: boolean = false
  order_id: string = ''

  mounted() {

  }
  getTime(val, type) {
    return formatDate(val, type)
  }
  getOrderDetails(val) {
    this.order_id = val.id
    this.is_show_order_info = true
  }
  closeOrder() {
    this.is_show_order_info = false
  }
  handleCurrentChange(val) {
    this.$emit('handle-page-change', {page: val})
  }
}
